export enum SkillAdvanceType {
    LEARN = "LEARNING",
    PRACTICE = "PRACTICE"
}